const state = {
  result: []
};

const mutations = {
  SET_RESULT(state, result) {
    state.result = result;
  }
};

const actions = {
  setResult({ commit }, result) {
    commit('SET_RESULT', result);
  }
};

export default {
  state,
  mutations,
  actions
};
